angular.module('impactx.sapconfig').controller('SAPEKOEditController', [
    '$scope',
    'dataGen',
    '$routeParams',
    'WarningService',
    'ConfirmationService',
    'BackService',
    'ToastService',
    'ToolbarService',
    SAPEKOEditController]);

function SAPEKOEditController($scope, dataGen, $routeParams, WarningService, ConfirmationService, BackService,
                              ToastService, ToolbarService) {
    var ctrl = this;

    $scope.preSetComId = {value: 0};

    dataGen.getData($scope, {id: $routeParams.id}, "/sapconfiguration/ekoview").then(function () {
        $scope.preSetComId.value = $scope.data.owningCompany.selected.id;
        defineButtons();
    });

    ctrl.checkAndSave = function ($event) {
        var warnings = ctrl.checkWarnings();
        if (warnings.length == 0) {
            return ctrl.save();
        }
        else {
            WarningService.showWarningDialog(ctrl.save, $event, $scope.trns.warning, $scope.trns.saveAnyway,
                $scope.trns.abort, warnings);
        }
    };

    ctrl.checkWarnings = function () {
        var warnings = [];
        var selectedCom = $scope.data.owningCompany.selected ? $scope.data.owningCompany.selected.id : 0;

        if ($routeParams.id > 0 && $scope.preSetComId.value != selectedCom) {
            warnings.push($scope.trns.warningComChanged)
        }
        return warnings;
    };

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.save = function () {
        var dataObj = {
            eko: $scope.data
        };
        return dataGen.postAsForm({}, dataObj, "/sapconfiguration/ekosave").then(function () {
            BackService.back();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm({}, dataObj, "/sapconfiguration/ekodelete").then(function () {
            BackService.back();
            ToastService.openStandardToast($scope.trns.deleteSuccess);
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.checkAndSave,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return $scope.data.id > 0 && !$scope.data.isDeprecated;
    }
}